import {
  AgentAttendanceDetailsAgent,
  AgentAttendanceDetailsShift,
  AgentAttendanceDetailsShiftMetrics,
  AgentStatus,
} from 'types'

export type AgentAttendanceFormattedData = Pick<
  AgentAttendanceDetailsShift,
  'startDate' | 'endDate'
> & {
  productive: boolean
  specialisation: string
  labels: string[]
  shiftId?: string
  assignedTicketCount?: number
  metrics?: Partial<AgentAttendanceDetailsShiftMetrics>
  agent?: AgentAttendanceDetailsAgent
  currentStatus?: AgentStatus | AgentAttendanceShiftState
  subRows?: AgentAttendanceFormattedData[]
}

export const AgentAttendanceShiftState = {
  Past: 'PAST',
  Upcoming: 'UPCOMING',
  Active: 'ACTIVE',
}
export type AgentAttendanceShiftState =
  (typeof AgentAttendanceShiftState)[keyof typeof AgentAttendanceShiftState]
